import { Injectable, Inject } from '@angular/core';
import { Observable,of, pipe, tap, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { API } from './api.config';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private baseUrl = environment.api;
  companyConfig: any = null //Se podría declarar una interfaz una vez el json sea "definitivo"

  constructor(
    private http: HttpClient
   ) {}

  loadCompanyConfig(): Observable<boolean> {

    const currentDomain = `${window.location.protocol}//${window.location.host}`
    
    //let params: HttpParams = new HttpParams();
    //params = params.append('cloudFrontdomain', currentDomain);
    //params = params.append('companyId', 200)

    const headers = new HttpHeaders({
      'client': environment.client,
      'apikey': environment.apikey,
      'channelId': '20',
      'accept-language': 'es',
      'accountCd': environment.keycloakRealm
    });

    /* En localhost obtenemos la configuración de un json */ 
    let urlGetConfig = `${this.baseUrl}${API.dipmal}${API.config}?companyId=500&cloudFrontdomain=${currentDomain}`;
    if(currentDomain.includes('localhost')){
      urlGetConfig = '../assets/json/companyConfig.json'
    }

    return this.http.get(urlGetConfig, { headers, withCredentials: false }).pipe(
      map((response) => {
        // do something to reflect into local model
        this.companyConfig = response
        return true;
      }),
      catchError((error) => {
        // if in error, set default fall back from environment
        //this.CreateConfig(defaultConfig);
        return of(false);
      })
    );
  }
}
